module.exports = __webpack_public_path__ + "img/approve-list19.ea5b7646.png";